import { render } from "./InspectReasonChart.vue?vue&type=template&id=50d6dbf4"
import script from "./InspectReasonChart.vue?vue&type=script&lang=js"
export * from "./InspectReasonChart.vue?vue&type=script&lang=js"

import "./InspectReasonChart.vue?vue&type=style&index=0&id=50d6dbf4&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__